<template>
  <main class="peekai-report">
    <iframe
      v-if="reportHtml"
      ref="reportFrame"
      class="peekai-report__frame"
      :srcdoc="reportHtml"
      :style="{ height: reportHeight }"
      title="PeekAI report"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-modals allow-downloads allow-popups"
      allow="clipboard-write"
      allowfullscreen
      @load="onReportLoad"
    ></iframe>
    <p v-else-if="errorMessage" class="peekai-report__error">{{ errorMessage }}</p>
  </main>
</template>

<script>
import { getPeekaiReportStatus, getPeekaiReportHtml } from '@/api/peekai'
import { DOCUMENT_TITLE_PREFIX } from '@/libs/constants'

export default {
  name: 'PeekaiReport',
  data () {
    return {
      reportHtml: '',
      reportHeight: '100vh',
      errorMessage: '',
      requestVersion: 0
    }
  },
  mounted () {
    window.addEventListener('message', this.onReportMessage)
    this.loadReport()
  },
  beforeDestroy () {
    this.requestVersion++
    window.removeEventListener('message', this.onReportMessage)
  },
  beforeRouteUpdate (to, from, next) {
    next()
    if (to.params.reportId !== from.params.reportId) this.loadReport(to.params.reportId)
  },
  methods: {
    loadReport (reportId = this.$route.params.reportId) {
      const requestVersion = ++this.requestVersion
      this.reportHtml = ''
      this.reportHeight = '100vh'
      this.errorMessage = ''

      return getPeekaiReportStatus(reportId)
        .then(result => {
          if (requestVersion !== this.requestVersion) return
          const brandName = result && typeof result.brandName === 'string'
            ? result.brandName.trim()
            : ''
          document.title = `${brandName || 'PeekAI Report'} | ${DOCUMENT_TITLE_PREFIX}`

          if (!result || !result.reportAvailable) {
            throw new Error('PeekAI report is not complete')
          }
          return getPeekaiReportHtml(reportId)
        })
        .then(html => {
          if (requestVersion !== this.requestVersion) return
          this.reportHtml = html
        })
        .catch(error => {
          if (requestVersion !== this.requestVersion) return
          this.errorMessage = error.message || 'Failed to load PeekAI report'
        })
    },
    onReportLoad () {
      const frame = this.$refs.reportFrame
      if (frame && frame.contentWindow) {
        frame.contentWindow.postMessage({ type: 'SET_PAGE_WIDTH' }, '*')
      }
    },
    onReportMessage (event) {
      const frame = this.$refs.reportFrame
      if (!frame || event.source !== frame.contentWindow) return
      if (!event.data || event.data.type !== 'resize') return

      const height = Number(event.data.height)
      if (Number.isFinite(height) && height > 0) {
        this.reportHeight = `${height}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.peekai-report {
  width: 100%;
  min-height: 100vh;
  background: #fff;

  &__frame {
    display: block;
    width: 100%;
    min-height: 100vh;
    border: 0;
  }

  &__error {
    margin: 0;
    padding: 40px;
    color: #666;
    text-align: center;
  }
}
</style>
